



























































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import CardDaftarOrderRingkas from "@/components/pemeriksaan/penunjang/CardDaftarOrderRingkas.vue";
import InputOrderPenunjang from "@/components/pemeriksaan/penunjang/InputOrderPenunjang.vue";
import { storePenunjang } from "@/store/modules/penunjang";
import { storeSoap } from "@/store/modules/soap";
import { userModule } from "@/store/modules/user";
import CardRiwayatHasilRingkas from "@/components/pemeriksaan/penunjang/CardRiwayatHasilRingkas.vue";

@Component({
  components: {
    CardDaftarOrderRingkas,
    InputOrderPenunjang,
    CardRiwayatHasilRingkas
  },
  inject: {
    isReadOnly: { default: () => () => false }
  }
})
export default class CardOrderPenunjangIgd extends Vue {
  @Prop() orderItems: Array<object>;
  @Prop() register!: string;
  @Prop() rm: string;
  @Prop() dataOrder!: Array<object>;
  @Prop() detailOrder!: object;
  @Prop() type!: string;
  @Prop() paste: Array<object>;
  @Prop() statusPaste: string;

  tglIsi = new Date().toISOString().substr(0, 10);
  today = new Date().toISOString().substr(0, 10);
  tglShow = false;
  maxDate = new Date().toISOString().substr(0, 10);
  tab = "history-hasil";
  modeForm = false;
  jumlahRiwayat: number | null = null;
  tabShowEvent = [
    { tab: "daftar-order", event: "getTabDaftar" },
    { tab: "history-hasil", event: "getTabHistory" }
  ];

  isReadOnly!: () => boolean;

  mounted() {
    const max = new Date(new Date().setDate(new Date().getDate() + 2));
    this.maxDate = max.toISOString().substring(0, 10);
  }

  get stateuser() {
    return userModule.user;
  }

  get readOnly(): boolean {
    return this.isReadOnly();
  }

  get bisaBuatOrder(): boolean {
    return this.stateuser.profesi == "Dokter" && !this.readOnly;
  }

  get jumlahOrder(): number | null {
    const memuat =
      this.type === "lab"
        ? storePenunjang.loadingOrderLab
        : storePenunjang.loadingOrderRadiologi;
    return memuat ? null : (this.dataOrder || []).length;
  }

  @Watch("bisaBuatOrder")
  changeBisaBuatOrder(val: boolean) {
    if (!val) this.modeForm = false;
  }

  get listRo() {
    return storePenunjang.listhasilRadiologi;
  }

  get listLab() {
    return storePenunjang.listhasilLab;
  }

  get title() {
    if (this.type === "ro") {
      return "Hasil Radiologi";
    } else if (this.type === "lab") {
      return "Hasil Lab";
    } else {
      return "???";
    }
  }

  get statesoapdetail() {
    return storeSoap.detailSoap;
  }

  @Watch("tab")
  changeTabs(val) {
    const tabEvent = this.tabShowEvent.find(item => item.tab === val);

    if (tabEvent) {
      this[tabEvent.event]();
    }
  }

  getTabDaftar() {
    if (this.type == "lab") {
      storePenunjang.act_all_order_lab_by_reg(this.register);
    }

    if (this.type == "ro") {
      storePenunjang.act_all_order_radiologi_by_reg(this.register);
    }
  }

  getTabCreate() {
    this.detailOrder = {};
  }

  getTabHistory() {
    const riwayat = this.$refs.riwayatHasil as Vue & { muat: () => void };
    if (riwayat) riwayat.muat();
  }

  detailHasil(val) {
    if (val["tipe"] == "ro") {
      storePenunjang.clear_hasil_ro();
      storePenunjang.act_hasil_ro_byReg(val);
    }
  }

  showItemModal(v) {
    this.$emit("show-item-modal", v);
  }

  showTabEditOrder(value) {
    this.modeForm = true;
    this.$emit("sendIdOrder", value);
  }

  bukaFormOrder() {
    this.getTabCreate();
    this.modeForm = true;
  }

  tutupFormOrder() {
    this.modeForm = false;
    this.getTabDaftar();
  }

  setOrderItems(items) {
    this.$emit("set-order-items", items);
  }

  showOrderList() {
    this.tab = "daftar-order";
  }

  alasanBatal(value) {
    this.$emit("alasanBatal", value);
  }

  backPageSoap() {
    this.$emit("pageTab", "tab-soap");
  }
}
